import { render, staticRenderFns } from "./ClipboardList.vue?vue&type=template&id=36326c2d"
import script from "./ClipboardList.vue?vue&type=script&lang=ts"
export * from "./ClipboardList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports